
import request from '../request'

export function upload(data) {
    return request({
        url: '/basic-service/file/upload',
        data,
        method: 'POST'
    })
}